import { AdminPartners } from "./partners";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { PlatformApp } from "@taunggyi-plus/app-shell";
import { AuthProvider } from "@taunggyi-plus/auth";
import { getAppConfig, installPageZoomLock } from "@taunggyi-plus/config";
import { CustomerInformationDialog, SupportChat } from "@taunggyi-plus/customer-feature";
import "@taunggyi-plus/design-system/styles.css";
import "./dashboard.css";
import { NotificationCenter } from "@taunggyi-plus/notifications";

import { AdminDashboard, AdminFinancePage, AdminMore, AdminOrdersPage } from "./admin-pages";

const authConfig = {
  appId: "admin",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

installPageZoomLock();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <PlatformApp
        config={getAppConfig("admin")}
        informationContent={(locale, id, onClose) => (
          <CustomerInformationDialog locale={locale} id={id} onClose={onClose} />
        )}
        navigationMode="owner"
        myServicesPath="/partners"
        myServicesLabel="Partners"
        myServicesContent={<AdminPartners />}
        contentOwnsHeading={["dashboard"]}
        moreContentOwnsHeadingPaths={["/more/taxi-drivers", "/more/taxi-leaders"]}
        dashboardContent={<AdminDashboard />}
        ordersContent={<AdminOrdersPage />}
        financeContent={<AdminFinancePage />}
        moreContent={(locale) => <AdminMore locale={locale} />}
        notificationContent={(locale) => (
          <NotificationCenter
            locale={locale}
            appId="admin"
            embedded
            webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
          />
        )}
      />
      <SupportChat admin />
    </AuthProvider>
  </StrictMode>,
);
